import useTheme from 'chat-ui/src/hooks/useTheme';
import UnauthIllustration from '@/assets/illustrations/unauth2-illustration.svg';
import TelletLogo from '@/assets/logo/tellet-logo-main.svg';
import EmpathyLogo from '@/assets/logo/empathy-logo-black.svg';
import Image from '@/components/atoms/Image';
import { Button, buttonVariants } from '@/components/ui/button';
import { ECompanyThemeName } from '@/enums';
import { useLogout } from '@/hooks/useUser';
import useTranslation from '@/hooks/useTranslation';

const themeLogosList = {
  [ECompanyThemeName.DEFAULT]: (
    <Image src={TelletLogo} alt="logo" className="absolute w-24 h-fit top-6 left-5" />
  ),
  [ECompanyThemeName.EMPATHY]: (
    <Image src={EmpathyLogo} alt="logo" className="absolute w-44 h-fit top-6 left-5" />
  ),
};

function AccountDeletedPage() {
  const logout = useLogout();
  const { themeName } = useTheme();
  const { lang } = useTranslation();

  return (
    <div className="relative flex items-center justify-center min-h-screen px-4 mx-auto text-center">
      {themeLogosList[themeName]}
      <div className="flex flex-col items-center justify-center gap-2 mx-auto text-center">
        <Image
          effect="blur"
          src={UnauthIllustration}
          alt="account deleted illustration"
          className="min500:w-full w-[450px]"
        />
        <h1 className="text-5xl font-bold mt-14 text-dark min500:text-4xl">
          {lang.get('msg.accountSuccessfullyDeleted')}
        </h1>
        <p className="mt-2 text-lg font-medium text-light-dark max-w-md">
          {lang.get('msg.accountDeletedThankYouMessage')}
        </p>
        <Button
          onClick={() => logout()}
          className={buttonVariants({
            variant: 'default',
            className: 'mt-5 transition-all ease-in-out hover:!bg-darker-primary',
          })}
        >
          {lang.get('msg.backToLogin')}
        </Button>
      </div>
    </div>
  );
}

export default AccountDeletedPage;
